// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import { useFormikContext } from 'formik';
import { Button, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';


// CUSTOM 
import InputNumeric from 'components/formFields/InputNumeric';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PersonAdd from '@mui/icons-material/PersonAdd';
import { DinamicFamilia } from './dinamicFamilia/DinamicFamilia'
import { storeFamilyBeneficiarios } from 'store/size_family';





export const Familia = (props:any) => {

  // DISPATCH  
  const dispatch = useDispatch();

  // REDUX 
  const { sizeFamilyBeneficiarios }: any = useSelector((state: any) => state.sizefamily);



  const formikProps:any = useFormikContext();

 

  const addMember = async() => {

    const currentFamily = formikProps.values.family || [];
    const newMember = {
      // Define aquí la estructura de un nuevo miembro vacío
      // o copia el último si prefieres, pero asegúrate de limpiar los valores
    };

    // Crea un nuevo array con el nuevo elemento al final
    const newArray = [...currentFamily, newMember];

    // Despacha la acción para actualizar el store (ajusta el action según tu implementación)
    // Esto es importante para que DinamicFamilia se re-renderice con el nuevo miembro
    await dispatch( storeFamilyBeneficiarios(newArray) );
    // También actualiza Formik
    formikProps.setFieldValue('family', newArray);
  }
  
  const { formField: {
    // DATOS CLIENTE 
    numOfBeneficiary

    }
  } = props;

  


  return (

    <>
        <Grid size={{ xs: 3 }}> 
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircleIcon />}
            endIcon={<PersonAdd />}
            onClick={addMember} // esta es tu función para agregar un beneficiario
            sx={{ mt: 2, borderRadius: 2 }}
          >
            Agregar Beneficiario
          </Button>
        </Grid>


        
         <DinamicFamilia children={sizeFamilyBeneficiarios} onOpenPdf={props.onOpenPdf} />
    </>
  )

}
